import React, { Component } from 'react'
import * as XLSX from 'xlsx';
import BsyAlertQrcode from "../BsyAlertQrcode";
import BsySwitchBtn from "../BsySwitchBtn";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import imgCodeAlert from "../BsyAlertImgCode/Staticize";
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import BsyDialog from '../BsyDialog';
import BsyApprovePane from '../BsyApprovePane';


class AlertListOutsider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            group_id: props.group_id,
            groupname: props.groupname,
            singleInvite: true,
            batchInvite: false,
            formRef: false,
            nicknameError: false,
            phoneError: false,
            emailError: false,
            openurl_switch: props.openurl_switch,
            openurl: props.openurl,
            approve_switch: props.approve_switch,
            nickname: "",
            phone: "",
            email: "",
            userUniqueId: "",
            excelName: "",
            excelTotal: "",
            corpId: "",
            errTipShow: false,
            nocheck: props.nocheck,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            excelTable: [],
            errInfo: [],
            emailCodeLogin: true,
            mobileCodeLogin: true,
            cacheKey: ""
        }
        this.copyCont = React.createRef();
    }

    componentDidMount() {
        React.axios('/corp/member/invite_openurl_get', {
            corpId: window.FX.STATIC.corpId
        }).then(res => {
            this.setState({ 
                emailCodeLogin: res.data.emailCodeLogin,
                mobileCodeLogin: res.data.mobileCodeLogin,
            })
        }).catch(res => {

        })
    }


    switchBody = (event) => {
        if (event.target.classList[0] === "menu-item") {
            for (let i = 0; i < event.target.parentNode.childNodes.length; i++) {
                event.target.parentNode.childNodes[i].classList.remove("active")
            }
            event.target.classList.add("active")
            if (event.target.classList[1] === "singleInvite") {
                this.setState({
                    singleInvite: true,
                    batchInvite: false,
                    formRef: false
                })
            } else if (event.target.classList[1] === "batchInvite") {
                this.setState({
                    singleInvite: false,
                    batchInvite: true,
                    formRef: false
                })
            } else if (event.target.classList[1] === "formRef") {
                this.setState({
                    singleInvite: false,
                    batchInvite: false,
                    formRef: true
                })
            }
        }
    }

    changeNickname = (event) => {
        const { value } = event.target
        this.setState({
            nickname: value,
            nicknameError: false
        })
    }

    changeUserUniqueId = (event) => {
        const { value } = event.target
        this.setState({
            userUniqueId: value
        })
    }

    changePhone = (event) => {
        const { value } = event.target
        this.setState({
            phone: value,
            phoneError: false
        })
    }

    emailValue = (rel) => {
        this.getEmail = rel
    }

    changeEmail = (event) => {
        const { value } = event.target
        this.setState({
            email: value,
            emailError: false
        })
    }

    handleCopy = () => {
        const spanText = this.copyCont.current.innerText;
        BsyUtils.copyToClipboard(spanText)
        tipAlert({
            type: "success",
            msg: React.language('app.edit.copy.success')
        });
    };

    manualClear = () => {
        this.setState({
            nickname: "",
            phone: "",
            userUniqueId: "",
        })
    }

    inviteClick = () => {
        const { nickname, userUniqueId, group_id, mobileCodeLogin, emailCodeLogin } = this.state
        let countryCode = this.getPhone.state.countryCode || '+86';
        let phone = this.getPhone.state.value;
        let email = this.getEmail.state.value;
        let requiredTip = "";

        if (nickname === "") {
            this.setState({ nicknameError: true })
            return
        }

        if((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin) ){
            requiredTip = React.language('invite.phone.and.email.required')
        }else if(!emailCodeLogin && mobileCodeLogin){
            requiredTip = React.language('invite.phone.required')
        }else if(emailCodeLogin && !mobileCodeLogin){
            requiredTip = React.language('invite.email.required')
        }

        if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin) ) {
            if (!email && !phone) {
                this.setState({ emailError: false, phoneError: false }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                return
            }
        } else {
            if (!phone && mobileCodeLogin) {
                this.setState({ phoneError: false }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                return
            }
            if(!email && emailCodeLogin){
                this.setState({ emailError: false }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                return
            }
        }


        ///corp/invite_check
        React.axios('/corp/invite_check', {}).then(res => {

            if (!res.data.check) {
                React.axios('/corp/outsider/invite', {
                    "name": nickname,  //必填 12 以内
                    "mobile": phone,  //必填
                    email: this.getEmail ? this.getEmail.state.value : null,
                    "country_code": countryCode, //必填
                    "uniqueid": userUniqueId,   //用户唯一id  32位以内
                    "group_id": group_id, //分组 必填
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        const { target, onRefresh } = this.props;
                        target.parentNode.remove();
                        tipAlert({
                            type: "success",
                            msg: res.data.msg
                        });
                        if (onRefresh) {
                            onRefresh();
                        }
                    })
                }).catch(res => {

                })
            } else {
                imgCodeAlert({
                    type: "success",
                    title: React.language('verification.img.code'),
                    onOk: (args) => {
                        if (!args.value) {
                            tipAlert({
                                type: "warning",
                                msg: React.language('code.not.empty')
                            });
                            return;
                        }
                        React.axios('/corp/outsider/invite', {
                            "name": nickname,  //必填 12 以内
                            "mobile": phone,  //必填
                            email: this.getEmail ? this.getEmail.state.value : null,
                            "country_code": countryCode, //必填
                            "uniqueid": userUniqueId,   //用户唯一id  32位以内
                            "group_id": group_id, //分组 必填
                            "ver_code": args.value //验证码
                        }).then(res => {
                            BsyUtils.showAjaxTip(res.data, () => {
                                const { target, onRefresh } = this.props;
                                if (args.onClose) {
                                    args.onClose()
                                }
                                if (onRefresh) {
                                    onRefresh();
                                }

                                target.parentNode.remove();
                                tipAlert({
                                    type: "success",
                                    msg: res.data.msg
                                });
                            }, () => {
                                //出错，重置验证码
                                if (args.onClose) {
                                    args.onClose()
                                }
                            })
                        }).catch(res => {
                            if (args.onClose) {
                                args.onClose()
                            }
                        })

                    }
                })
            }

        }).catch(res => {

        })



    }

    _column_2_number = (s) => {
        let result = 0;
        let len = s.length;
        let ch;
        let A = 'A'.charCodeAt();
        for (let i = len - 1; i >= 0; i--) {
            ch = s[i];
            ch = s.charCodeAt(i);
            result = (result + ((ch - A) + 1) * Math.pow(26, len - 1 - i));
        }
        return result;
    }

    _parse_sample_ex2 = (a) => {
        let y_s = 0;
        let x_e = 0;
        let y_e = 0;
        let ref = a['!ref']
        let reg1 = /([a-zA-Z]+)([0-9]+):([a-zA-Z]+)([0-9]+)/ig;
        let res1 = reg1.exec(ref)
        y_s = Number(res1[2]) - 1;
        x_e = this._column_2_number(res1[3]);
        y_e = Number(res1[4]);
        let result = new Array(y_e > 500 ? 500 : y_e);
        let array_value = new Array(y_e);
        for (let i = y_s; i < y_e; i++) {
            array_value[i] = [];
            if (i < 500)
                result[i] = [];
            for (let j = 0; j < x_e; j++) {
                array_value[i][j] = "";
                if (i < 500)
                    result[i][j] = {};
            }
        }
        for (let k in a) {
            let reg = /([a-zA-Z]+)([0-9]+)/ig;
            let res = reg.exec(k)
            if (!res)
                continue;
            let x = this._column_2_number(res[1]) - 1;
            let y = Number(res[2]) - 1;
            let val = { value: a[k].v, type: a[k].t };
            if (y < 500)
                result[y][x] = val;
            array_value[y][x] = a[k].v;
        }
        this.setState({
            array_value: array_value,
            excelTotal: array_value.length - 1
        })
        return result;
    }

    _previewExcelData = (a1, event) => {
        const txt = React.language('role.import.tip');
        // eslint-disable-next-line no-unused-vars
        let { cacheKey, sheetName, formName, excel_data, cuurmobiletype } = this.state
        let wb;
        let f = a1[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            wb = XLSX.read(data, { type: 'binary' });
            cacheKey = a1.cacheKey;
            sheetName = wb.SheetNames[0];
            var b = a1;
            a1 = [];
            a1.sheetList = wb.SheetNames;
            formName = React.language("import.form");
            if (b && b.length > 0) {
                (formName = b[0].name.replace(".xlsx", "").replace(".xls", ""));
                if (wb.Sheets[sheetName].hasOwnProperty("!merges")) {
                    tipAlert({
                        type: "warning",
                        msg: txt
                    });
                    event.target.value = '';
                }
                else {
                    //必填手机号码，手机号码为空直接过滤当前数据
                    excel_data = wb.Sheets;
                    let items = this._parse_sample_ex2(wb.Sheets[sheetName]), g = true;
                    let array_value = [];
                    cuurmobiletype = false;
                    if (items.length > 0) {
                        //unique
                        if (g) {
                            if ((array_value.length - 1) <= 200) {
                                this.setState({ excelName: f.name.replace(".xlsx", "").replace(".xls", ""), excelTable: items })
                                event.target.value = '';
                            } else {
                                tipAlert({
                                    type: "warning",
                                    msg: '数据条数超过限制，最大值为200条'
                                });
                                event.target.value = '';
                            }
                        } else {
                            tipAlert({
                                type: "warning",
                                msg: txt
                            });
                            event.target.value = '';
                        }
                    } else {
                        tipAlert({
                            type: "warning",
                            msg: txt
                        });
                        event.target.value = '';
                    }
                }
            }
        }

        reader.readAsBinaryString(f);
    }

    uploadFile = (event) => {

        const img = event.target.files;
        this._previewExcelData(img, event);
    }

    downFile = () => {
        window.location.href = window.rootDirectroy + '/wps/' + React.language('wps.xlsx.name1')
    }

    importClick = () => {
        const { excelTable, group_id } = this.state
        const c = window.FX.Utils.createLoadLayer(window.$('.invite-body'), {
            isLight: !0,
            hasLoader: !0
        });
        React.axios("/corp/outsider/import", {
            excel: excelTable,
            group_id: group_id
        }).then(res => {
            c.remove()
            const data = res.data
            if (data.hasOwnProperty("msg") && data.hasOwnProperty("code") && data.code > 0) {
                tipAlert({
                    type: "warning",
                    msg: data.msg
                })
                return;
            }

            var t = data.data;
            if (t.success > 0) {
                this.setState({
                    errInfo: t.errinfo,
                    excelTable: t.info,
                    errCount: t.errcount,
                    existCount: t.existcount,
                    newCount: t.newcount,
                    errTipShow: true
                })
                if (t.newcount > 0) {

                    const { onRefreshAll } = this.props;
                    if (onRefreshAll) {
                        onRefreshAll();
                    }
                }
            } else {
                // tipAlert({
                //     type: "warning",
                //     msg: '系统错误，导入失败'
                // })
            }
        }).catch(res => {

        })
    }

    downErrorInfo = () => {
        const { errInfo } = this.state
        React.axios("/corp/outsider/downloaderr", {
            excel: errInfo
        }).then(res => {
            var h = res.data.data;
            if (h.success > 0) {
                window.location.href = h.info;
            }
        }).catch(res => {

        })
    }

    doneClick = () => {
        this.setState({
            singleInvite: false,
            batchInvite: true,
            formRef: false,
            nicknameError: false,
            phoneError: false,
            showLink: false,
            nocheck: false,
            nickname: "",
            phone: "",
            userUniqueId: "",
            excelName: "",
            excelTotal: "",
            corpId: "",
            errTipShow: false,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            excelTable: [],
            errInfo: [],
            cacheKey: ""
        })
    }

    qrcodeAlert = (event) => {
        event.stopPropagation()
        const pot = event.currentTarget.getBoundingClientRect()
        const css = 160 > (document.documentElement.clientHeight - pot.top + event.currentTarget.offsetHeight + 2) ? {
            left: pot.left + 'px',
            minWidth: event.currentTarget.offsetWidth,
            bottom: document.documentElement.clientHeight - pot.top + 2 + 'px'
        } : {
            left: pot.left + 'px',
            minWidth: event.currentTarget.offsetWidth,
            top: pot.top + event.currentTarget.offsetHeight + 2 + 'px'
        }
        const { openurl } = this.state
        BsyAlertQrcode({
            value: openurl,  //value参数为生成二维码的链接
            size: 160, //二维码的宽高尺寸
            css: css,
            text: React.language('msg.qrCode'),
            fgColor: "#000000"
        })
    }

    phoneValue = (rel) => {
        this.getPhone = rel
    }

    closeAlter = () => {
        const { target } = this.props;
        target.parentNode.remove();
    }

    switchChange = (val) => {

        React.axios('/corp/outsider/update', {
            openurl_switch: val,
            group_id: this.state.group_id
        }).then(res => {
            this.setState({ openurl_switch: val })
            const { onRefreshOusiders } = this.props;
            if (onRefreshOusiders) {
                onRefreshOusiders({ openurl_switch: val });
            }
        }).catch(res => {

        })
    }

    approve_switch_Change = (val) => {

        React.axios('/corp/outsider/update', {
            isCheck: val,
            group_id: this.state.group_id
        }).then(res => {
            this.setState({ approve_switch: val })
            const { onRefreshOusiders } = this.props;
            if (onRefreshOusiders) {
                onRefreshOusiders({ isCheck: val });
            }
        }).catch(res => {

        })
    }

    approve_list = (val) => {

        const { group_id, groupname } = this.state
        BsyDialog({
            title: React.language('outsiderGroup') + ' - ' + groupname,
            height: 600,
            width: 966,
            noFooter: true,
            onContentCreate: () => {
                return <BsyApprovePane
                    group_id={group_id} mode={'outsider'} status={3} />

            }
        })

    }

    render() {
        const { batchInvite, singleInvite, formRef, nickname, phone, userUniqueId, nicknameError, phoneError, excelName, excelTotal, excelTable,
            errTipShow, errCount, existCount, newCount, openurl, nocheck, openurl_switch, approve_switch, email, emailError, mobileCodeLogin, emailCodeLogin } = this.state
        const { title, styleCss } = this.props
        return (
            <div className={"content " + window.mode} style={styleCss}>
                <div className="dialog-header">
                    <span className="title">{title}</span>
                    <i onClick={this.closeAlter} className="icon-close-large" />
                </div>
                <div className="dialog-body">
                    <div className="invite-menu" onClick={this.switchBody}>
                        <div className="menu-item singleInvite active">{React.language('outsider.member.singleAdd')}</div>
                        <div className="menu-item batchInvite">{React.language('outsider.member.batchAdd')}</div>
                        <div className="menu-item formRef">{React.language('member.invite.public.link')}</div>
                    </div>
                    <div className="invite-body">
                        {singleInvite && <div className="singleInvite">
                            <div className="manualCont">
                                <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('name')}</div>
                                        <div className="label-tip">
                                            *
                                        </div>
                                    </div>
                                    <input className={nicknameError ? "error" : ""} value={nickname} maxLength="64" onChange={this.changeNickname} type="text" placeholder={React.language('max.length.64')} />
                                </div>
                                <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('phone')}</div>
                                        {
                                            (mobileCodeLogin || (!emailCodeLogin && !mobileCodeLogin)) ? <div className="label-tip">*</div> : ''
                                        }

                                    </div>

                                    <LoginAccountInput getValue={this.phoneValue} change={this.changePhone} error={phoneError} maxLength="12" value={phone} mode="mobile" placeholder={React.language('phone.entry.tip')} />
                                </div>
                                {
                                    <div className="input-item">
                                        <div className="input-label">
                                            <div className="label-title">{React.language('email')}</div>
                                            {
                                                (emailCodeLogin || (!emailCodeLogin && !mobileCodeLogin)) ? <div className="label-tip">*</div> : ''
                                            }

                                        </div>
                                        {
                                            <LoginAccountInput getValue={this.emailValue} change={this.changeEmail} error={emailError} maxLength="128" value={email} mode="email" placeholder={React.language('email.entry.tip')} />
                                        }
                                    </div>
                                }
                                <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('enterprise.userID')}</div>
                                    </div>
                                    <input value={userUniqueId} onChange={this.changeUserUniqueId} type="text" placeholder={React.language('enterprise.tip2')} />
                                </div>
                            </div>
                            <div className="manualBtn">
                                <BsyIconBtn
                                    text={React.language('clear')}
                                    type="white"
                                    click={this.manualClear}
                                    mode={window.mode}
                                />
                                <BsyIconBtn
                                    text={React.language('add')}
                                    type="blue"
                                    click={this.inviteClick}
                                    mode={window.mode}
                                />
                            </div>
                        </div>}
                        {batchInvite && <div className="batchInvite">
                            {errTipShow ? <div className="batchErrTip">
                                <div className="errorTip">
                                    {React.language('batch.error.tip', { success: newCount, exist: existCount, error: errCount })}
                                </div>
                                <div className="errorBtn">
                                    <BsyIconBtn
                                        text={React.language('batch.error.btn')}
                                        type="white"
                                        click={this.downErrorInfo}
                                        mode={window.mode}
                                    />
                                </div>
                            </div> : <div className="batchBtn">
                                <div className={"r-btn " + window.mode}>
                                    <i className="icon-bsy-file" />
                                    <span>{React.language('widget.file.select')}</span>
                                    <form className="upload-form " action="" encType="multipart/form-data"
                                        method="post">
                                        <input onChange={this.uploadFile} type="file" name="file" id="file"
                                            className="upload-btn-input" accept=".xlsx,.xls" />
                                    </form>
                                </div>
                                <BsyIconBtn
                                    text={React.language('Download.btn1')}
                                    iconName="icon-bsy-reportmenu-8"
                                    type="r-btn white  "
                                    click={this.downFile}
                                    mode={window.mode}
                                />
                            </div>}
                            {excelTable.length <= 0 && <div className="batchTip">
                                <p>{React.language("widget.file.select")}</p>
                                <ul>
                                    <li>
                                        {nocheck ? React.language("outsider.member.import.Download01") : React.language("invite.Download8")}</li>
                                </ul>
                                <p>{React.language("invite.Download.title")}</p>
                                <ul>
                                    <li>{React.language("outsider.member.import.Download11")}</li>
                                    <li>{React.language("outsider.member.import.Download12")}</li>
                                    <li>{React.language("outsider.member.import.Download13")}</li>
                                    <li>{React.language("outsider.member.import.Download14")}</li>
                                    <li>{React.language("outsider.member.import.Download15")}</li>

                                </ul>
                            </div>}
                            {excelTable.length > 0 && <div className="batchTable">
                                <div className="invite-content">
                                    <div className="excel-import-tool">
                                        <span>{React.language('excel')}-{excelName}</span>
                                        <span style={{ float: 'right' }}>{React.language("Total.data")}{excelTotal}{React.language('tiao')}</span>
                                    </div>
                                    <div className="excel-import-table">
                                        <div className={"excel-import-grid react_excel_grid " + (errTipShow ? "import" : "")}
                                            style={{ width: 'auto', maxHeight: '160px' }}>
                                            <div className="excel-border">

                                            </div>
                                            <table cellPadding="0" cellSpacing="0">
                                                <tbody>
                                                    <tr className="row-head">
                                                        <td className="row-idx" rowSpan="1"><span
                                                            className="row-num">1</span><span
                                                                className="row-label">{React.language('import.rowHead')}</span>
                                                        </td>
                                                        {
                                                            excelTable[0].map((val, key) => {
                                                                return <td key={key}><span>{val.value}</span></td>
                                                            })
                                                        }
                                                    </tr>
                                                    {
                                                        excelTable.map((val, key) => {
                                                            return key !== 0 && <tr key={key}>
                                                                <td className="row-idx" rowSpan="1"><span
                                                                    className="row-num">{key + 1}</span><span
                                                                        className="row-label">{React.language('import.rowHead')}</span>
                                                                </td>
                                                                {
                                                                    val.map((val1, key1) => {
                                                                        return <td key={key1}><span>{val1.value}</span></td>
                                                                    })
                                                                }
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {errTipShow ? <div className="invite-btn">
                                    <BsyIconBtn
                                        text={React.language('done')}
                                        type="blue"
                                        click={this.doneClick}
                                        mode={window.mode}
                                    />
                                </div> : <div className="invite-btn">
                                    <BsyIconBtn
                                        text={React.language('import')}
                                        type="blue"
                                        click={this.importClick}
                                        mode={window.mode}
                                    />
                                    <BsyIconBtn
                                        text={React.language('cancel')}
                                        type="white"
                                        click={this.doneClick}
                                        mode={window.mode}
                                    />
                                </div>}
                            </div>}
                        </div>}
                        {formRef && <div className="form-ref">
                            <div className="ref-list">
                                <div className="list-label">
                                    <span className={"list-title"}>{React.language('member.invite.link')}</span>
                                    <span className="label-info">{React.language('member.invite.link.tip')}</span>
                                    {openurl_switch}
                                    <BsySwitchBtn key={formRef} power={openurl_switch} switchChange={this.switchChange} />
                                </div>
                            </div>
                            {openurl_switch && <div className="ref-list">
                                <div className="list-label link">
                                    <span className={"list-title"}>{React.language('link.address')}</span>
                                </div>
                                <div className="list-label link share">
                                    <div className="url item" ref={this.copyCont}>{openurl}</div>
                                    <div className="copy item" onClick={this.handleCopy}>{React.language('copy')}</div>
                                    <div className="qr item" onClick={this.qrcodeAlert}>
                                        <i className="icon-qrcode" />
                                    </div>
                                </div>
                            </div>}
                            {
                                openurl_switch &&
                                <div className="ref-list">
                                    <div className="list-label">
                                        <span className={"list-title"}>{React.language('member.invite.link.Audit')}</span>
                                        <span className="label-info">{React.language('member.invite.link.Audit.tip')}</span>
                                        <div className="Audit" >
                                            <BsySwitchBtn power={approve_switch} switchChange={this.approve_switch_Change} />

                                        </div>
                                    </div>
                                </div>

                            }
                            <BsyIconBtn
                                text={React.language('member.invite.link.Audit.list')}
                                type="blue"
                                // iconName="icon-bsy-audit-list"
                                click={this.approve_list}
                                mode={window.mode}
                            />
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default AlertListOutsider